import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled, { injectGlobal, ThemeProvider } from 'styled-components'
import { theme, globalStyle } from '../theme'
import AudioProvider from '../components/AudioProvider'
import Container from '../components/Container'
// import Footer from '../components/Footer'
import RoomChooserModalConnected from '../components/RoomChooserModal'
import XylophoneAffirm1Audio from '../assets/audio/xylophone_affirm1.wav'
import ToiletAudio from '../assets/audio/toilet.m4a'
import QuizModalConnected from '../components/QuizModal'

injectGlobal`${globalStyle}`

// const FooterPositioner = styled.div`
//   bottom: 0;
//   left: 0;
//   position: fixed;
//   right: 0;
//   z-index: 1;
// `

const audioFiles = {
  xyl1: XylophoneAffirm1Audio,
  toilet: ToiletAudio,
}

const DebugOutlines = styled.div`
  * {
    outline: 1px solid gold;
  }
`

export default class MainLayout extends Component {
  static propTypes = {
    children: PropTypes.func,
  }

  static Container = Container

  render() {
    const { children } = this.props

    const ContainerComp = this.constructor.Container

    return (
      <AudioProvider sources={audioFiles}>
        <ThemeProvider theme={theme}>
          {/*
          <DebugOutlines>
          */}
          <ContainerComp>
            <Helmet
              titleTemplate="%s | Home Energy Tips"
              defaultTitle="Home Energy Tips"
            />
            {children()}

            {/* <FooterPositioner>
              <FooterComp colorScheme="blue" />
            </FooterPositioner> */}

            <RoomChooserModalConnected />
            <QuizModalConnected />
          </ContainerComp>
          {/*
          </DebugOutlines>
          */}
        </ThemeProvider>
      </AudioProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.js